import React, { useState } from 'react';
import { MdRefresh, MdExpandMore, MdExpandLess } from 'react-icons/md';

const CollapsibleSection = ({ title, children, defaultOpen = true, onRerun, rerunning = false }) => {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div className="bg-white dark:bg-[#161b22] border border-gray-200 dark:border-gray-800 rounded-lg mb-4">
      <div className="flex items-center justify-between px-4 py-3 border-b border-gray-200 dark:border-gray-800">
        <button
          type="button"
          className="flex items-center gap-2 text-left flex-1"
          onClick={() => setOpen(!open)}
        >
          {open ? <MdExpandLess className="text-gray-400" /> : <MdExpandMore className="text-gray-400" />}
          <span className="text-sm font-semibold text-gray-900 dark:text-gray-100 uppercase tracking-wider">
            {title}
          </span>
        </button>
        {onRerun && open && (
          <button
            type="button"
            onClick={(e) => { e.stopPropagation(); onRerun(); }}
            disabled={rerunning}
            className="text-[#c9a96e] hover:text-[#b8985d] disabled:opacity-40 ml-2"
            title="Recompute (bypass cache)"
          >
            <MdRefresh className={`text-lg ${rerunning ? 'animate-spin' : ''}`} />
          </button>
        )}
      </div>
      {open && <div className="p-4">{children}</div>}
    </div>
  );
};

export default CollapsibleSection;
